import { render, staticRenderFns } from "./VRecaptcha.vue?vue&type=template&id=c6b95ea6"
import script from "./VRecaptcha.vue?vue&type=script&lang=js"
export * from "./VRecaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports